import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function VideoCamera(): React.ReactElement {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#videoCameraIcon)">
        <path d="M10.3299 3.22229H1.11111C0.497685 3.22301 0.000723378 3.71998 0 4.3334V11.6453C0.000723378 12.2587 0.497685 12.7557 1.11111 12.7564H10.3299C10.9431 12.7557 11.4402 12.2587 11.441 11.6453V4.3334C11.4402 3.71998 10.9431 3.22301 10.3299 3.22229Z" fill="white" fillOpacity="0.4"/>
        <path d="M12.1836 9.51132L16.0019 11.596V4.40686L12.1836 6.4915V9.51132Z" fill="white" fillOpacity="0.4"/>
      </g>
      <defs>
        <clipPath id="videoCameraIcon">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}
